import './ArrowDiagonalIcon.less';
import React from 'react';

const ArrowDiagonalIcon = ({ className }) => (
    <svg className={'icon arrow-diagonal-icon ' + className} viewBox="0 0 14 14">
        <path d="M13.25 0h.017c.02 0 .04.002.06.004L13.25 0c.047 0 .093.004.137.013l.034.007c.024.005.046.012.068.019l.03.011c.02.007.039.015.057.024l.043.023c.018.01.035.02.051.032l.031.022c.057.043.108.093.15.15l-.07-.081c.036.037.069.077.096.119.014.02.026.041.037.063l.014.026c.012.027.024.055.034.085l.006.019c.011.037.02.076.025.116L14 .75v6.5c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L12.5 7.25V2.56L1.28 13.78c-.293.293-.767.293-1.06 0-.267-.266-.29-.683-.073-.976l.073-.084L11.438 1.5H6.75c-.38 0-.693-.282-.743-.648L6 .75c0-.38.282-.693.648-.743L6.75 0h6.5z" />
    </svg>
);
export default ArrowDiagonalIcon;
